import store, {epicMiddleware} from './common-store'
import rootEpic from './epics/presenter-epic'



if (rootEpic !== null) {

  epicMiddleware.run(rootEpic)

}

export const storeDispatch = store.dispatch

export default store